<template>
  <div class="box-big">
    <com-header :id="id" :list="list" @initMenu="initMenu"></com-header>
    <el-container>
      <el-aside
        width="collapse"
        ref="myAside"
        :style="{ width: !isCollapse ? '270px' : '96px' }"
      >
        <div class="menu-box">
          <el-menu
            router
            :unique-opened="true"
            :default-active="$route.path"
            :collapse="isCollapse"
            class="el-menu-vertical"
          >
            <template v-for="submenu in curList">
              <el-submenu
                :index="submenu.data.menuName"
                v-if="submenu.children && submenu.children.length > 0"
              >
                <template slot="title">
                  <div class="left-test-father">
                    <img
                      style="height: 24px;margin-right: 6px;vertical-align: middle;"
                      :src="
                        require(`@/assets/image/${submenu.data.menuCode}.png`)
                      "
                      alt=""
                    />
                    <div class="tit" v-if="isCollapse == true"></div>
                    <div class="tit" v-if="isCollapse == false">
                      {{ submenu.data.menuName }}
                    </div>
                  </div>
                </template>
                <template v-for="menu in submenu.children">
                  <el-menu-item
                    :index="menu.data.menuUrl"
                    :key="menu.data.menuUrl"
                  >
                    <div class="left-test">
                      <!-- <div style="width: 4px; height: 4px; background: #fff; border-radius: 50%;"></div> -->
                      <div style="margin-left: 8px;">
                        {{ menu.data.menuName }}
                      </div>
                    </div>
                  </el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item
                v-else
                :index="submenu.data.menuUrl"
                :key="submenu.data.menuUrl"
                class="menu-item"
              >
                <img
                  style="height: 24px;margin-right: 6px;vertical-align: middle;"
                  :src="submenu.data.menuIcon"
                  alt=""
                />
                <div class="tit" slot="title">{{ submenu.data.menuName }}</div>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
        <div class="footer-box">
          <div class="layout-header-logo">
            <div class="qiehuan" ref="qiehuan" @click="qiehuan">
              <div class="icon" :class="[isCollapse ? 'go' : 'aa']">
                <i class="el-icon-s-fold"></i>
              </div>
            </div>
          </div>
        </div>
      </el-aside>
      <div
        :style="{
          width: !isCollapse ? 'calc(100% - 270px)' : 'calc(100% - 96px)'
        }"
      >
        <el-main class="main-content" :style="defaultHeight">
          <router-view></router-view>
          <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="800px"
            :modal="true"
            :close-on-click-modal="false"
          >
            <div>
              <el-form
                :model="formData"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
              >
                <el-form-item prop="old" label="旧密码">
                  <el-input
                    show-password
                    v-model="formData.old"
                    placeholder="请输入旧密码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="newPassword" label="新密码">
                  <el-input
                    show-password
                    v-model="formData.newPassword"
                    placeholder="请输入薪密码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="confirmNewPassword" label="确认新密码">
                  <el-input
                    show-password
                    v-model="formData.confirmNewPassword"
                    placeholder="请输入确认新密码"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false" size="mini"
                >取 消</el-button
              >
              <el-button
                type="primary"
                class="search"
                size="mini"
                @click="cancelcerat"
              >
                <span>确 定</span>
              </el-button>
            </div>
          </el-dialog>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script>
import "./iconfont/iconfont.css";
import leftnav from "./leftnav1";
import { setUserPassword } from "@/api/systemManagement";
import CryptoJS from "crypto-js";
import { getPermission } from "@/api/sso";
import comHeader from "@/components/comp-header/index.vue";
export default {
  components: { comHeader },
  data() {
    return {
      menuURL: "",
      gang: false,
      collapseBtnClick: true,
      timer: "",
      user: {},
      desbel: null,
      dialogVisible: false,
      topList: [],
      natlist: null,
      activeIndex: "",
      lefList: [],
      list: [],
      token: null,
      key: "u9dYuYlGVk39kkb5",
      userName: "",
      FULL_CHARTER: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopgrstuvwxyz",
      clientId:
        "system_manage0000000000000000000db327c39298cfa18b2473fc8c489a5d5",
      isCollapse: false,
      title: "",
      defaultHeight: {
        height: ""
      },
      formData: {
        confirmNewPassword: "",
        old: "",
        newPassword: ""
      },
      rules: {
        confirmNewPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur"
          },
          {
            pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,50}$/,
            message: "密码必须同时包含字母、数字和特殊字符其中三项且⾄少6位"
          }
        ],
        old: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          },
          {
            pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,50}$/,
            message: "密码必须同时包含字母、数字和特殊字符其中三项且⾄少6位"
          }
        ]
      },
      defaultActive: "",
      id: "",
      curList: []
    };
  },
  watch: {
    "$route.path"(val) {
      sessionStorage.setItem("curDefaultActive", val);
    }
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.getUserShow();
  },
  methods: {
    initMenu(array) {
      this.curList = array;
      if (this.curList.length) {
        if (this.curList[0].children && this.curList[0].children.length)
          this.desbel = this.curList[0].children[0].data.menuUrl;
        else this.desbel = this.curList[0].data.menuUrl;

        if (sessionStorage.getItem("curDefaultActive")) {
          this.defaultActive = sessionStorage.getItem("curDefaultActive");
        } else {
          this.defaultActive = this.desbel;
          sessionStorage.setItem("curDefaultActive", this.desbel);
        }

        this.$router.push({
          path: `${this.defaultActive}`
        });
      }
    },
    qiehuan() {
      this.$nextTick(() => {
        this.isCollapse = !this.isCollapse;
      });
    },
    async cancelcerat() {
      let xx = true;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      if (this.formData.confirmNewPassword != this.formData.newPassword) {
        this.$message({
          message: "两次密码不一致",
          type: "warning"
        });
        return false;
      }
      let params = {
        newPassword: this.encryptByAES(this.formData.newPassword, this.key),
        old: this.encryptByAES(this.formData.old, this.key)
      };
      const res = await setUserPassword(params);
      if (res.data.code == 200) {
        this.$message({
          message: "修改密码成功",
          type: "success"
        });
        this.dialogVisible = false;
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 修改密码
    modifyPassword() {
      this.formData.confirmNewPassword = "";
      this.formData.old = "";
      this.formData.newPassword = "";
      this.dialogVisible = true;
    },
    encryptByAES(message, key) {
      var iv = "LT0cYheDsyKGHENw";
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var ivHex = CryptoJS.enc.Utf8.parse(iv);
      var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    // 获取菜单权限和用户信息
    async getUserShow() {
      let params = {
        accessToken: `Bearer ${this.token}`
      };
      const res = await getPermission(params);

      if (res.data.code == 200 && res.data.data && res.data.data.length) {
        let menuList = [];
        res.data.data.map(item => {
          if (item.data.menuCode == "auth-menu") {
            this.list = item.children;
            menuList = JSON.parse(JSON.stringify(item.children));
          }
        });
        if (menuList.length) {
          let curList =
            menuList.find(item => item.children && item.children.length) || [];
          this.id = curList.id;
          this.initMenu(curList.children);
          sessionStorage.setItem(
            "menuChildren",
            JSON.stringify(curList.children)
          );
        }
      }
    },
    getHeight() {
      this.defaultHeight.height = window.innerHeight + "px";
    }
  }
};
</script>

<style scoped lang="less">
.box-big {
  background: #f1f4f6;
}

.el-menu-vertical {
  overflow: hidden;
}

.el-aside {
  position: relative;

  .footer-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.15);

    .qiehuan {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.7);
      border: none;

      .icon {
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-menu {
  background-color: rgba(36, 42, 63, 1);
  // margin-top: 60px;
}

.el-menu-item.is-active {
  background-color: rgba(0, 139, 255, 0.15) !important;
  color: #008bff !important;
}

.el-menu-item:hover {
  color: #666 !important;
  background-color: rgba(0, 139, 255, 0.05) !important;
}

.box-big {
  // background: url(../../assets/pic/header_BgImg.png) no-repeat;
  // background-size: 100% 100%;
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  // text-align: center;
}

.el-header {
  padding-right: 30px;
}

.box {
  width: 224px;
  height: 100%;
  background-color: red;
}

.el-container .el-aside {
  text-align: center;
  background: #242a3f;
  border: none;
  padding: 0;
  margin: 0;
  width: 270px;
}

.menu-box {
  padding: 24px 16px;
  height: calc(100vh - 64px);
  overflow: auto;
}

.el-main {
  background-color: #fff;
  color: #333;
  // margin-left: 20px;
  height: 840px;
  padding: 0;
}

.navigation {
  height: 100%;
}

.menu-item.el-menu-item {
  text-align: left;
  line-height: 48px;
  height: 48px;
  margin-top: 4px;
}

.menu-item.el-menu-item .tupian {
  display: inline-block;
  font-size: 18px;
}

.menu-item.el-menu-item .tit {
  display: inline-block;
  color: #ffffff;
}

.menu-item.el-menu-item:hover .left-test-father {
  background: transparent !important;
}

.menu-item.el-menu-item.is-active .tit {
  background: transparent !important;
  color: #ffffff;
}

.layout-left {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
}

.left-test {
  display: flex;
  align-items: center;
  justify-content: left;
  padding-left: 40px;
  color: #92979c;
}

.left-test-father {
  display: flex;
  width: 100%;
  font-size: 14px;
  height: 45px;
  font-family: SourceHanSansCN-mini, SourceHanSansCN;
  margin-top: 10px;
  align-items: center;
}

.left-test-father i {
  font-size: 18px;
  color: #666666;
}

.tupian {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
}

.el-menu-item {
  margin: 0 0px;
}

#elMenu .el-menu-item-group__title {
  padding: 0 !important;
}

.el-menu {
  border-right: none;
}

#elMenu {
  height: calc(100% - 5px);
  background: #fff;
  position: relative;
  width: 100%;
}

/deep/.el-submenu__title,
/deep/.el-menu-item {
  // color:#8A909A;
  font-size: 16px;
  line-height: 40px;
}

.child-menu ::before {
  position: relative;
  display: inline-block;
  vertical-align: 3px;
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #8a909a;
  margin-right: 10px;
}

.font16 {
  font-size: 18px;
  font-weight: 500;
  margin-left: 8px;
  color: #8a909a;
}

.el-aside .el-menu.el-menu--inline {
  padding: 0 8px !important;
}

.el-aside .el-menu-item.is-active {
  background: linear-gradient(225deg, #01bfea 0%, #0047fe 100%) !important;
  color: #fff !important;
  border-radius: 8px !important;
}

.el-aside .el-menu-item.is-active .left-test {
  color: #fff;
}

.iconfont {
  color: #fff;
}

.el-menu-item:hover {
  background: linear-gradient(225deg, #01bfea 0%, #0047fe 100%) !important;
  color: #fff !important;
  border-radius: 8px !important;

  .left-test {
    color: #fff;
  }
}

.el-submenu .el-menu-item {
  height: 48px;
  line-height: 48px;
  color: #fff;
  width: 100%;
  margin: 4px 0;
  padding: 0;
}

.el-menu-item.is-active .child-menu ::before {
  background: #004ad1;
}

.el-menu-item:hover .child-menu ::before {
  background: #004ad1;
}

/deep/ .el-submenu.is-opened .el-submenu__title i {
  color: #fff !important;
}

.el-submenu .el-submenu__title .tit {
  color: #ffffff !important;
  font-weight: 400;
}

.el-submenu.is-opened .el-submenu__title .tit {
  color: #ffffff !important;
  font-weight: 600;
}

.el-submenu:hover .el-submenu__title .tit {
  color: #ffffff !important;
  font-weight: 600;
}

/deep/.el-submenu.is-active .el-submenu__title {
  background-color: rgba(0, 144, 255, 0.15) !important;
  border: 0;
  height: 48px;
  border-radius: 8px;
}

/deep/.el-submenu__title:hover {
  background-color: rgba(0, 144, 255, 0.15);
  border: 0px;
  border-radius: 8px;
}

.el-tabs__item {
  height: 50px !important;
  line-height: 50px;
  background-color: #ccc;
}

.el-submenu__icon-arrow el-icon-arrow-down :before {
  color: #004ad1 !important;
}

/deep/ .el-submenu__icon-arrow {
  font-size: 15px;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 224px;
}

.aa {
  transition: transform 0.2s;
}

.go {
  transform: rotate(180deg);
  transition: transform 0.2s;
}

.el-menu-item.is-active {
  background: linear-gradient(225deg, #01bfea 0%, #0047fe 100%) !important;
  color: #fff !important;
  border-radius: 8px !important;
  .left-test {
    color: #fff !important;
  }
}

.main-content {
  height: calc(100vh - 64px) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/index.vue